export const MODAL_WIDTH = 350
export const calculateShiftModalStyles = (cellRef: React.MutableRefObject<HTMLDivElement>) => {
  const { bottom, left, height } = cellRef.current.getBoundingClientRect()

  const modalStyles = {
    content: {
      bottom: Math.floor(window.innerHeight - bottom + height - 10),
      // check if modal is going out of screen
      left: left + MODAL_WIDTH > window.innerWidth ? window.innerWidth - MODAL_WIDTH : left,
      position: 'absolute',
    },
  }

  return modalStyles
}
